package com.crowpay.views.dialogs

import com.crowpay.completionResponse.DisputeType
import com.crowpay.views.theming.*
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.Property
import com.lightningkite.kiteui.reactive.bind
import com.lightningkite.kiteui.reactive.equalTo
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.atEnd
import com.lightningkite.kiteui.views.card
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.expanding

class DisputeWorkItemConfirmation(
    val action: suspend (DisputeType?)->Unit,
): Page {

    private val selection = Property<DisputeType?>(null)

    override fun ViewWriter.render2(): ViewModifiable {
        return dismissBackground {
            sizeConstraints(maxWidth = 50.rem) - centered - ModernDialog.onNext - col {
                title("Select Dispute Type")

                LargeSelectionCards.onNext - row {
                    expanding - sizeConstraints(aspectRatio = 1.2) - card - radioToggleButton {
                        col {
                            spacing = appTheme.spacing
                            title("Work Item Dispute")
                            body("Dispute only this work item. This will allow work to continue in other work items, but this work item will be frozen until the dispute is resolved.")
                        }
                        checked bind selection.equalTo(DisputeType.LineItem)
                    }
                    expanding - sizeConstraints(aspectRatio = 1.2) - card - radioToggleButton {
                        col {
                            spacing = appTheme.spacing
                            title("Project Dispute")
                            body("Dispute the whole project. This will put all other work items on hold, freezing work on the project until the dispute is resolved.")
                        }
                        checked bind selection.equalTo(DisputeType.ProjectWide)
                    }
                }

                atEnd - row {
                    secondaryButton - button {
                        specCenteredText("Go Back")
                        onClick { action(null) }
                    }
                    sizeConstraints(width = 8.rem) - DisputeButton.onNext - button {
                        ::enabled { selection() != null }
                        specCenteredText("Begin")
                        onClick { action(selection.value ?: return@onClick) }
                    }
                }
            }

            onClick {
                action(null)
            }
        }
    }
}